import { httpClient } from '../http/httpClient'
import { SupportRequestReason } from '@/app/entities/SupportRequest'

export interface SupportRequestReasonOption {
  label: string
  value: SupportRequestReason
}

export async function getSupportReasons() {
  const { data } = await httpClient.get<SupportRequestReasonOption[]>(
    '/support-requests/reasons',
  )

  return data
}
